import _ from 'underscore';
import xtend from 'xtend';

import PreferenceModelManager from '@invintusmedia/preference-model-manager-v3';
import Store from '../../../lib/store/store-v2';

export default function (apiBus) {
    const KEY = 'preferenceID';
    var state = Store();

    function addUpdateResponseHandler (resp) {
        const preference = PreferenceModelManager.handleFetchResolved(
            'listing', resp
        );

        state.set({
            isResolving: false,
            data: preference,
            preferenceID: resp.data.preferenceID
        });
    }

    var overrides = {
        edit: addUpdateResponseHandler,
        add: addUpdateResponseHandler,
        getByID: function (resp) {
            const preference = PreferenceModelManager.handleFetchResolved(
                'listing', resp
            );

            state.set({
                isResolving: false,
                data: preference
            });
        }
    };

    var apiActions = Store.ApiActions(state, KEY, overrides);
    Store.SubscribeToApi(apiActions, apiBus);

    return {
        state: state
    };
};
